import React, { useEffect, useState } from 'react';
import { AppBackdrop } from 'modules/common/components';
import { useFeatureFlag } from 'modules/common/hooks';
import { delay } from 'utils/delay';
import { useApplyProgress } from './hooks/useApplyProgress';

type ApplyProgressProps = {
  isProcessing: boolean;
};
export const ApplyProgress: React.FC<ApplyProgressProps> = ({
  isProcessing
}: ApplyProgressProps) => {
  const progress = useApplyProgress(isProcessing);

  // if progress is greater than 0 and isprocessing is false,
  // then make progress 100 for 300ms to show additional completed icon before closing progress modal
  const [open, setOpen] = useState(isProcessing);
  const [finished, setFinished] = useState(false);
  const isBetterUxEnabled = useFeatureFlag('isSmartDiaryBetterUxEnabled');

  useEffect(() => {
    const setProcessing = async () => {
      if (isProcessing) {
        setOpen(true);
        setFinished(false);
      } else if (isBetterUxEnabled && !isProcessing && progress > 0) {
        setFinished(true);
        await delay(300);
        setOpen(false);
      } else if (!isBetterUxEnabled && !isProcessing) {
        setFinished(true);
        setOpen(false);
      }
    };
    setProcessing();
  }, [isProcessing, progress, isBetterUxEnabled]);

  return <AppBackdrop open={open} progress={finished ? 100 : progress} />;
};
